exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pqRpcALXzrddg17Jb2oMb{font-size:16px;height:16px;line-height:31px;width:16px;color:var(--neutralSecondary)!important}html[dir=ltr] .pqRpcALXzrddg17Jb2oMb{margin-left:16px;margin-right:12px}html[dir=rtl] .pqRpcALXzrddg17Jb2oMb{margin-right:16px;margin-left:12px}html[dir] ._256upTASbj9za7mTcpQlAL{padding-bottom:16px}html[dir] .GCD3mE-DvwJiL8c9g0Y9L{padding-bottom:14px}html[dir] ._1_z1lH1CDG5QrQQajYQJgc{padding-bottom:16px}", ""]);
// Exports
exports.locals = {
	"iconRoot": "pqRpcALXzrddg17Jb2oMb",
	"iconRootComputer": "_256upTASbj9za7mTcpQlAL",
	"iconRootCloud": "GCD3mE-DvwJiL8c9g0Y9L",
	"iconRootUploadAndShare": "_1_z1lH1CDG5QrQQajYQJgc"
};